module.exports = __webpack_public_path__ + "img/b2bprologo.224e4d25.png";